module.exports = __webpack_public_path__ + "static/media/water-stream.13676175.mp3";